import axios from '@/global-config/request/axios-config';
import schema from "@/global-config/validator/validation-config";
import {useToast} from "vue-toastification";
import ToastificationContent from "@/components/common/ToastificationContent";
import Datepicker from 'vue3-datepicker'
import { ref } from 'vue'
import snsWebSdk from "@sumsub/websdk";
import feather from 'feather-icons';
const CryptoJS = require("crypto-js");




export const globalMixin = {
    // setup() {
    //     // Get toast interface
    //     const toast = useToast();
    //
    //     // Use it!
    //     toast("I'm a toast!");
    //
    //     // or with options
    //     toast.success("My toast content", {
    //         timeout: 2000
    //     });
    //     // These options will override the options defined in the "app.use" plugin registration for this specific toast
    //
    //     // Make it available inside methods
    //     return { toast }
    // },
    mounted() {
        // Number.prototype.toFixed = function(digits) {
        //     var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        //         m = this.toString().match(re);
        //     return m ? parseFloat(m[1]) : this.valueOf();
        // };
        this.initializeFirebase()
        feather.replace();
    },
    updated() {
        // Replace icons after any re‑render (e.g., filter changes)
        feather.replace();
    },
    data() {
        return {
            schema,
            successMessage: 'success',
            errorMessage: 'error',
            pendingRequest: false,
            currency: null,
            publicPath: process.env.BASE_URL,
            toastG: useToast(),
            sideBarNav: 'dashboard-overview',
            messaging: null,
            notificationCount : 0,
            exportFileDownloadUrl:'https://efun.ae/public/',
            subSubApiurl:'https://test-api.sumsub.com',
            amountDecimalPlaces:3,
            feesDecimalPlaces:3,
            upperLimitDate: new Date(),
            secretEncryptKey: 'test',
        }
    },
    methods: {
        encryptData(data) {
            // Convert the integer ID to a string
            if (typeof data === "number") {
                data = data.toString();
            }

            return CryptoJS.AES.encrypt(data, this.secretEncryptKey).toString();
        },
        decryptData(encryptedData) {
            return  CryptoJS.AES.decrypt(encryptedData, this.secretEncryptKey).toString(CryptoJS.enc.Utf8);
        },
        isEmpty(obj) {
            if (obj == null) {
                return true
            }
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop)) {
                    return false;
                }
            }
            if(typeof obj.length != 'undefined'){
                if(obj.length){
                    return false
                }
                else{
                    return true
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        },
        removeCookie(cookieName)
        {
            /*
            * Note that javascript is not directly removing the session:
            * the client reads the cookie, invalidates it and sends the proper information
            * to the server, which then expires the session accordingly
            * */
            let cookieValue = "";
            let cookieLifetime = -1;
            var date = new Date();
            date.setTime(date.getTime()+(cookieLifetime*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
            document.cookie = cookieName+"="+JSON.stringify(cookieValue)+expires+"; path=/";
        },
        isLoadedScript(lib) {
            return document.querySelectorAll('[src="' + lib + '"]').length > 0
        },
        copyText(text) {
            // navigator.clipboard.writeText(text);
            // this.toastG({
            //     component: ToastificationContent,
            //     props: {
            //         title: 'Text Copied',
            //         icon: 'BellIcon',
            //         text: text,
            //         variant: 'success',
            //     },
            // })

            if (typeof (navigator.clipboard) == 'undefined') {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    this.toastG({
                        component: ToastificationContent,
                        props: {
                            title: 'Text Copied',
                            icon: 'BellIcon',
                            text: text,
                            variant: 'success',
                        },
                    })
                } catch (err) {
                    this.toastG({
                        component: ToastificationContent,
                        props: {
                            title: 'Text Copied',
                            icon: 'BellIcon',
                            text: "Error Could not Copy",
                            variant: 'danger',
                        },
                    })
                }

                document.body.removeChild(textArea)
                return;
            }
            navigator.clipboard.writeText(text);
            this.toastG({
                component: ToastificationContent,
                props: {
                    title: 'Text Copied',
                    icon: 'BellIcon',
                    text: text,
                    variant: 'success',
                },
            })

        },
        async makeRequest(requestType = 'get', url, data = {}, optionalConfig = {}, showSuccessMsg = true,showErrorMsg = true) {
            // this.toastG.info("I'm an info toast!");

            data.uri = this.endpointMapper(url) ? this.endpointMapper(url) : url

            url = '/'
            // url = 'api/'
            // url = 'test.php' // for local


            /*
            if a request is still pending then the next
            request will not be made to the server until its response is received*/
            if (this.pendingRequest) {
                return;
            }
            let responseFormat = {}
            let requestObj = null;
            switch (requestType) {
                case 'get':

                    requestObj = axios.get(url, data);
                    break;

                case 'post':
                    requestObj = axios.post(url, data, optionalConfig);
                    break;

                case 'put':
                    requestObj = axios.put(url, data, optionalConfig);
                    break;

                case 'delete':
                    requestObj = axios.delete(url, data);
                    break;

                default:
                    /*if no params matches in switch case*/
                    requestObj = axios.get(url, data);

            }

            this.pendingRequest = true;
            await requestObj.then(callResponse => {
                /*success*/
                responseFormat.error = false;
                responseFormat.response = callResponse;
                let code = responseFormat.response.data.code
                if (code == 200) {
                    if (showSuccessMsg)
                        // this.$toast.success(responseFormat.response.data.message);
                        this.toastG({
                            component: ToastificationContent,
                            props: {
                                title: 'Success',
                                icon: 'BellIcon',
                                text: '👋 ' + responseFormat.response.data.message,
                                variant: 'success',
                            },

                        }, {toastClassName: 'badge-glow badge-success'})
                } else if (code == 401) {
                    if(typeof callResponse.data?.redirectTo != "undefined"){
                        this.$router.push({name: callResponse.data?.redirectTo});
                        return
                    }
                    if(showErrorMsg){
                        this.toastG({
                            component: ToastificationContent,
                            props: {
                                title: 'Error',
                                icon: 'BellIcon',
                                text: '👋 ' + responseFormat.response.data.message,
                                variant: 'danger',
                            },

                        }, {toastClassName: 'badge-glow badge-danger'})
                    }
                    localStorage.clear();
                    this.$router.push({name: 'send-otp'});
                    return
                } else {
                    if (responseFormat.response.data.message == '') {
                        this.$toast.error('Error! An error occurred');
                        this.toastG({
                            component: ToastificationContent,
                            props: {
                                title: 'Error',
                                icon: 'BellIcon',
                                text: 'An error occurred',
                                variant: 'danger',
                            },
                        }, {toastClassName: 'badge-glow badge-danger'})
                    } else {
                        // this.$toast.error(responseFormat.response.data.message);
                        this.toastG({
                            component: ToastificationContent,
                            props: {
                                title: 'Error',
                                icon: 'BellIcon',
                                text: '👋 ' + responseFormat.response.data.message,
                                variant: 'danger',
                            },

                        }, {toastClassName: 'badge-glow badge-danger'})
                    }
                }

            }).catch(error => {
                /*error*/
                responseFormat.error = true;
                responseFormat.response = error;
                // this.$toast.error('Error! An error occurred');
                this.toastG({
                    component: ToastificationContent,
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        text: '👋 An error occurred',
                        variant: 'danger',
                    },
                })
            }).finally(() => {
                this.pendingRequest = false;

            });


            return responseFormat;
        },
        initializeFirebase(){
            var config = {
                // 'messagingSenderId': '52722100684',
                'messagingSenderId': '158322870799',
                // 'apiKey': 'AIzaSyCO0fd5e5HpN-Sjqi4Vj_j3rH7FE4XSwG4',
                'apiKey': 'AIzaSyCoCU2kbigq4eZZxkxA-LOlS9IdMqG2D_o',
                // 'projectId': 'test-a03e0',
                'projectId': 'vaultspay-59ed4',
                // 'appId': '1:52722100684:web:46c7021571b80f84fb9569',
                'appId': '1:158322870799:web:76bdc203215cabc2dbf17a',
            };
            if (!firebase.apps.length) {
                firebase.initializeApp(config);
            }else {
                firebase.app(); // if already initialized, use that one
            }

            this.messaging = firebase.messaging();
            this.messaging.onMessage((payload) => {
                this.notificationCount += 1
                this.emitter.emit("notification-count", this.notificationCount)
                // console.log(payload)
                // if(typeof(payload.data) != 'undefined'){
                //     if(typeof(payload.data.custom) !='undefined'){
                //         let customData = JSON.parse(payload.data.custom)
                //         if(typeof customData.accountLogin){
                //             if(customData.accountLogin == 1){
                //                 this.$store.dispatch('showLogoutPopup',true)
                //             }
                //         }
                //
                //     }
                // }

                this.toastG({
                    component: ToastificationContent,
                    props: {
                        title: payload.notification.title,
                        icon: 'BellIcon',
                        text: '👋 ' + payload.notification.body,
                        variant: 'warning',
                    },

                }, {toastClassName: 'badge-glow badge-warning'})
            });
        },
        async requestPermission(){
            var fcmToken = null
            await  this.messaging
                .requestPermission()
                .then(() => {
                    // console.log("Notification permission granted.");

                    // get the token in the form of promise
                    return this.messaging.getToken()
                })
                .then((token) => {
                    fcmToken = token
                })
                .catch((err) => {
                    console.log("Unable to get permission to notify.", err);
                });

            return fcmToken;

        },
        endpointMapper(uri) {
            let uris = {
                'v1/get-dashboard-feature-list' : 'v1/dashboard-feature',
                'v1/transaction-types' : 'v1/transaction-types',
                'v1/get-transactions' : 'v1/fetch-transactions',
                'v1/get-pending-transactions' : 'v1/fetch-pending-transactions',
                'v1/get-failure-transactions' : 'v1/fetch-failure-transactions',
                'v1/get-merchant-customers' : 'v1/fetch-merchant-customers',
                'v1/get-wallet-list' : 'v1/get-wallet',
                'v1/get-balance-on-hold' : 'v1/get-hold-balance',
                'v1/create-refund-request' : 'v1/make-refund-request',
                'v1/get-account-ledger' : 'v1/get-ledger',
                'v1/get-all-refunds' : 'v1/get-all-refunds',
                'v1/cancel-refund-request' : 'v1/cancel-refund-request',
                'v1/verify-email' : 'v1/send-otp' ,
                'v1/verify-otp' : 'v1/otp-verify' ,
                'v1/login' : 'v1/user-login' ,
                'v1/register' : 'v1/sign-up' ,
                'v1/passcode-login' : 'v1/login-with-passcode' ,
                'v1/set-passcode' : 'v1/set-passcode' ,
                'v1/get-merchant-app-settings' : 'v1/fetch-merchant-app-settings' ,
                'v1/update-merchant-app-credentials' : 'v1/update-merchant-app-credentials' ,
                'v1/get-payment-link-info' : 'v1/fetch-payment-link-info' ,
                'v1/get-payment-methods' : 'v1/fetch-payment-methods' ,
                'v1/add-new-payment-link' : 'v1/add-new-payment-link' ,
                'v1/update-payment-link' : 'v1/update-payment-link' ,
                'v1/get-paymentlink-transactions' : 'v1/fetch-paymentlink-transactions' ,
                'v1/get-api-payments' : 'v1/fetch-api-payments' ,
                'v1/logout-user' : 'v1/logout' ,
                'v1/add-merchant-staff' : 'v1/add-merchant-staff' ,
                'v1/get-merchant-staff' : 'v1/fetch-merchant-staff' ,
                'v1/update-merchant-staff' : 'v1/update-merchant-staff' ,
                'v1/get-staff-features' : 'v1/fetch-staff-features' ,
                'v1/manage-staff-features' : 'v1/manage-staff-features' ,
                'v1/generate-report' : 'v1/generate-report' ,
                'v1/get-user-kyc' : 'v1/fetch-user-kyc' ,
                'v1/manage-user-kyc' : 'v1/manage-user-kyc' ,
                'v1/upload-user-kyc-file' : 'v1/upload-user-kyc-file' ,
                'v1/verify-email-general' : 'v1/verify-email-general' ,
                'v1/reset-password' : 'v1/reset-password' ,
                'v1/reset-passcode' : 'v1/reset-passcode' ,
                'v1/notifications' : 'v1/notifications' ,
                'v1/settlements' : 'v1/settlements' ,
                'v1/get-user-data' : 'v1/get-user-data' ,
            }

            if (typeof (uris[uri]) != 'undefined')
                return uris[uri]
            else
                return null

        },
        downloadReport(requestData, uri = 'v1/generate-report'){

            requestData.page = this.$store.getters.getChosenPage
            requestData.perPage = this.$store.getters.getChosenPerPage

            if(requestData.exportAs == 'excel'){
                this.$store.dispatch('exportExcelLoader',true)
            }else{
                this.$store.dispatch('exportPdfLoader',true)
            }
            this.makeRequest('post', uri, requestData, {}, false).then(callResponse => {

                if(typeof(callResponse) != 'undefined'){

                    if (!callResponse.error) {
                        let code = callResponse.response.data.code;

                        if (code == 200) {
                            let data = callResponse.response.data.data
                            // if(typeof(data.file_id) != 'undefined'){
                            //     let url = this.exportFileDownloadUrl+'api/v1/download-report?file_id='
                            //     window.open(url+data.file_id, "_blank");
                            // }
                            // if(typeof(data.url) != 'undefined'){
                            //     window.open(data.url, "_blank");
                            // }

                            if (data && typeof (data.url) != 'undefined') {
                                window.open(data.url, "_blank");
                            }else if(data && typeof(data.file) != 'undefined'){
                                window.open(data.file, '_blank');
                            }
                        }
                    }

                }

                if(requestData.exportAs == 'excel'){
                    this.$store.dispatch('exportExcelLoader',false)
                }else{
                    this.$store.dispatch('exportPdfLoader',false)
                }

            });
        },
        launchWebSdk(apiUrl, flowName, accessToken,successRouteFrom, applicantEmail, applicantPhone, customI18nMessages) {
            this.sdkIntialized = true
            let snsWebSdkInstance = snsWebSdk.init(accessToken,   (newAccessTokenCallback) => {
                // Access token expired
                // get a new one and pass it to the callback to re-initiate the WebSDK
                let newAccessToken = newAccessToken(); // get a new token from your backend
                newAccessTokenCallback(newAccessToken)
            })
                .withConf({
                    lang: 'en', //languge of WebSDK texts and comments (ISO 639-1 format)
                    email: applicantEmail,
                    phone: applicantPhone,
                    i18n: customI18nMessages,
                    uiConf: {
                        customCss: "https://url.com/styles.css"
                        // URL to css file in case you need change it dynamically from the code
                        // the similar setting at Applicant flow will rewrite customCss
                        // you may also use to pass string with plain styles `customCssStr:`
                    },
                })
                .on('idCheck.onApplicantSubmitted', (payload) => {
                    this.sdkIntialized = false
                    document.querySelector("#app").style["display"] = 'none'
                    // see below what kind of messages the WebSDK generates
                    // console.log('WebSDK onMessage', type, payload)
                    if(successRouteFrom == 'passcode-login'){
                        var newUrl = window.location.href.replace('auth/passcode-login','app/');
                        window.location.href = newUrl
                    }else if(successRouteFrom == 'set-passcode'){
                        var newUrl = window.location.href.replace('auth/set-passcode','auth/passcode-login');
                        window.location.href = newUrl
                    }
                })
                .on('idCheck.onError', (error) => {
                    this.sdkIntialized = false
                })
                .on('idCheck.onInitialized', () => {
                    document.querySelector("#app").style["display"] = 'none'
                    this.sdkIntialized = false
                })
                .build();

            // you are ready to go:
            // just launch the WebSDK by providing the container element for it
            snsWebSdkInstance.launch('#sumsub-websdk-container')
        },
        customFormatDateTime(value){
            // return new Date(value).toLocaleString().replace(',',' ').replace('/','-').replace('/','-').replace(/:[^:]*$/,'')
            // return new Date(value).toLocaleString().replace(',',' ').replace('/','-').replace('/','-')
            // return new Date(value).toLocaleString([], { hour: '2-digit', minute: '2-digit',year: 'numeric', month: 'numeric', day: 'numeric' })
            return new Date(value).toLocaleString([], { hour: '2-digit', minute: '2-digit',second: '2-digit',year: 'numeric', month: 'numeric', day: 'numeric' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3')
        },
        convertDuration(min) {
            return {
                days: Math.floor(min / 24 / 60),
                hours: Math.floor(min / 60 % 24),
                mins: Math.floor(min % 60),
            }
        },
        formatDate(val){
            let date = new Date(val)
            let day = ("0" + date.getDate()).slice(-2)
            let month = ("0" + (date.getMonth() + 1)).slice(-2)
            let year= date.getFullYear()

            return year+'-'+month+'-'+day
        },
        isValidateFileSize(input,limitInMB = 0.6) {
            const fileSize = input.size / 1024 / 1024; // in MiB
            if (fileSize > limitInMB) {
                return false
            }
            return true
        },
        formatSectionName(name) {
            return name
                .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
                .replace(/_/g, " ") // Replace underscores with spaces
                .replace(/\b\w/g, c => c.toUpperCase()) // Capitalize first letter of each word
                .trim(); // Remove leading/trailing spaces
        },
        isLoggedInByAdmin() {
            return document.cookie.includes('admin_login=true')
        },
        deleteAdminLoginCookie() {
            document.cookie = "admin_login=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
            document.cookie = "xbrowwser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        },
        clearAllCookies() {
            document.cookie.split(";").forEach((cookie) => {
                document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/");
            });
        }
    },
    watch: {
        sideBarNav() {

        }
    }
}
